import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class OracleWrapper extends DatabaseWrapper {

	//side Tab options show and hide
	showDatabaseTab = true;

	//repConn
	showRepConnHost = true;
	showRepConnPort = true;
	showRepConnUsr = true;
	showRepConnPwd = true;
	showRepConnDBVersion = true;
	showRepConnServiceNm = true;
	showRepConnAgent = true;


	/*isCaseSensitive = true;
	isPublicSynonym = true;*/
	isShowObjProperties = true;

	//repConn

	//Databases
	repConnGridTitleNm = 'schemaNm';

	dataObjectConnDatabaseNm = 'Schema';
	hideSchemaNmColumn = false;
	hideDatabaseNmDbColumn = true;
	gridEditable = true;
	isShowPIIColumn = true;
	maxLength = 30;


	//showRepConnProperties = true;

	showRepConnFTPGroup = false;
	showRepConnFileLocation = false;
	showRepConnHadoopDistribution = false;
	showRepConnSecToken = false;
	showRepConnUrl = false;
	showRepConnSSHGroupHDFS = false;
	showRepConnConnType = false;
	showRepConnSSHGroup = false;
	showRepConnHDFSGroup = false;
	showOracleRepConnDatabaseType = true;
	//DDS-7472 Connection to oracle cloud  	
	showRepConnUserName = false;
	showRepConnPassword = false;
	showRepConnOracleWalletLocation = false;
	showRepConnTNSalias = false;
	//showRepConnDBVersion= false;
	showRepConnTrustStoreLocation = false;
	showRepConnTrustStorePassword = false;
	showRepConnKeystoreLocation = false;
	showRepConnKeystorePassword = false;
	showOracleCloudTypes = false;
	showRepConnSSLVersion = false;
	//Import
	mandatorySchemaName = true;


	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.oracle.ID;
		this.name = DatabaseEnum.oracle.NAME;
		this.code = DatabaseEnum.oracle.CODE;
		this.equivalentTag = DatabaseEnum.oracle.EQUIVALENT_TAG;
		this.conn_DbsTabName = 'Schemas';
		//data object tabs
		this.showDataObjectPropertiesTab = true;
		this.hideSchemaNmColumn = false;
		this.showDDLOption = true;
		this.showViewDataTabOption = true;
		this.isShowObjProperties = true;
		this.isShowPIIColumn = true;
		this.hideDatabaseNmDbColumn = true;
		this.havingOnlySchemalColumn = true;
		this.showRepConnServiceNm = true;
		this.dataObjectConnDatabaseNm = 'Schema';
		this.databaseNmDbColumnName = "Service";
		this.showDataDescription = false;
	}

	validateRepConn(repConnWrapper: RepConnWrapper): void {
		if (repConnWrapper.repConn.conn.conndbtype == 'Oracle on-premise') {
			if (repConnWrapper.repConn.conn.host == "") {
				repConnWrapper.inValid_Cds.push('NO_HOST');
			}

			if (repConnWrapper.repConn.conn.port == "") {
				repConnWrapper.inValid_Cds.push('NO_PORT');
			}

			if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
				repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
			}

			if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
				repConnWrapper.inValid_Cds.push('NO_PASSWORD');
			}

			if (repConnWrapper.repConn.conn.wrhloc == "") {
				repConnWrapper.inValid_Cds.push('NO_SERVICE_NM');
			}
			if (repConnWrapper.repConn.conn.authentication == "SSL") {
				if (repConnWrapper.repConn.conn.ssl_keyStore == undefined || repConnWrapper.repConn.conn.ssl_keyStore == "") {
					repConnWrapper.inValid_Cds.push('NO_SSL_KEYSTORE');
				}
				if (repConnWrapper.repConn.conn.ssl_keyStorePassword == undefined || repConnWrapper.repConn.conn.ssl_keyStorePassword == "") {
					repConnWrapper.inValid_Cds.push('NO_SSL_KEYSTOREPWD');
				}
				if (repConnWrapper.repConn.conn.ssl_trustStore == undefined || repConnWrapper.repConn.conn.ssl_trustStore == "") {
					repConnWrapper.inValid_Cds.push('NO_SSL_TRUSTSTORE');
				}
				if (repConnWrapper.repConn.conn.ssl_trustStorePassword == undefined || repConnWrapper.repConn.conn.ssl_trustStorePassword == "") {
					repConnWrapper.inValid_Cds.push('NO_SSL_TRUSTSTOREPWD');
				}
				if (repConnWrapper.repConn.conn.secAuth == undefined || repConnWrapper.repConn.conn.secAuth == "") {
					repConnWrapper.inValid_Cds.push('NO_SSL_PROTOCOL');
				}
				// if (repConnWrapper.repConn.conn.ssl_cipherSuites == undefined || repConnWrapper.repConn.conn.ssl_cipherSuites == "") {
				// 	repConnWrapper.inValid_Cds.push('NO_SSL_CIPHERSUITES');
				// }
				if (repConnWrapper.repConn.conn.ssl_version == undefined || repConnWrapper.repConn.conn.ssl_version == "") {
					repConnWrapper.inValid_Cds.push('NO_SSL_VERSION');

				}
			}

		}

		if (repConnWrapper.repConn.conn.conndbtype == 'Oracle Autonomous Cloud' && repConnWrapper.repConn.conn.storagetype == 'Oracle Wallet') {
			if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
				repConnWrapper.inValid_Cds.push('NO_CONN_USER');
			}

			if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
				repConnWrapper.inValid_Cds.push('NO_PASSWORD');
			}
			if (repConnWrapper.repConn.conn.secKeyTab == "") {
				repConnWrapper.inValid_Cds.push('NO_TNS');
			}

			if (repConnWrapper.repConn.conn.url == "") {
				repConnWrapper.inValid_Cds.push('NO_WALLET_LOC');
			}
		}
		if (repConnWrapper.repConn.conn.conndbtype == 'Oracle Autonomous Cloud' && repConnWrapper.repConn.conn.storagetype == 'Java Key Store') {

			if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
				repConnWrapper.inValid_Cds.push('NO_CONN_USER');
			}

			if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
				repConnWrapper.inValid_Cds.push('NO_PASSWORD');
			}
			if (repConnWrapper.repConn.conn.secKeyTab == "") {
				repConnWrapper.inValid_Cds.push('NO_TNS');
			}

			if (repConnWrapper.repConn.conn.url == "") {
				repConnWrapper.inValid_Cds.push('NO_WALLET_LOC');
			}
			if (repConnWrapper.repConn.conn.ssl_trustStore == "") {
				repConnWrapper.inValid_Cds.push('TRUST_STORE_LOC');
			}

			if (repConnWrapper.repConn.conn.ssl_trustStorePassword == "") {
				repConnWrapper.inValid_Cds.push('TRUST_STORE_PASSWORD');
			}
			if (repConnWrapper.repConn.conn.ssl_keyStore == "") {
				repConnWrapper.inValid_Cds.push('NO_KEYSTORELOC');
			}

			if (repConnWrapper.repConn.conn.ssl_keyStorePassword == "") {
				repConnWrapper.inValid_Cds.push('NO_KEYSTOREPASS');
			}
			if (repConnWrapper.repConn.conn.ssl_version == "") {
				repConnWrapper.inValid_Cds.push('SSL_VER');
			}
		}

		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}

		if (repConnWrapper.repConn.conn_Dbs.length < 1) {
			repConnWrapper.inValid_Cds.push('NO_DATABASE');
		} else {

		}
	}

	showDataPointProperties(repConnWrapper: RepConnWrapper): void {

		///	repConnWrapper.repConn.databaseNmDbColumnName = "Service";
		if (repConnWrapper.repConn.conn.conndbtype == 'Oracle on-premise') {
			this.showRepConnHost = true;
			this.showRepConnPort = true;
			this.showRepConnUsr = true;
			this.showRepConnPwd = true;
			this.showRepConnDBVersion = true;
			//this.showRepConnServiceNm = true;
			//this.storeRepConnServiceNm = true;
			this.showRepConnAgent = true;

			this.showRepConnUserName = false;
			this.showRepConnPassword = false;
			this.showRepConnOracleWalletLocation = false;
			this.showRepConnTNSalias = false;
			this.showRepConnTrustStoreLocation = false;
			this.showRepConnTrustStorePassword = false;
			this.showRepConnKeystoreLocation = false;
			this.showRepConnKeystorePassword = false;
			this.showOracleCloudTypes = false;
			this.showRepConnSSLVersion = false;

		} else if (repConnWrapper.repConn.conn.conndbtype == 'Oracle Autonomous Cloud') {
			this.showOracleCloudTypes = true;
		}
		if (repConnWrapper.repConn.conn.conndbtype == 'Oracle Autonomous Cloud' && repConnWrapper.repConn.conn.storagetype == 'Oracle Wallet') {
			this.showRepConnUserName = true;
			this.showRepConnPassword = true;
			this.showRepConnOracleWalletLocation = true;
			this.showRepConnTNSalias = true;
			this.showRepConnDBVersion = false;
			this.showRepConnTrustStoreLocation = false;
			this.showRepConnTrustStorePassword = false;
			this.showRepConnKeystoreLocation = false;
			this.showRepConnKeystorePassword = false;
			this.showRepConnAgent = true;
			this.showRepConnSSLVersion = false;
		}
		if (repConnWrapper.repConn.conn.conndbtype == 'Oracle Autonomous Cloud' && repConnWrapper.repConn.conn.storagetype == 'Java Key Store') {
			this.showRepConnUserName = true;
			this.showRepConnPassword = true;
			this.showRepConnOracleWalletLocation = true;
			this.showRepConnTNSalias = true;
			this.showRepConnDBVersion = false;
			this.showRepConnTrustStoreLocation = true;
			this.showRepConnTrustStorePassword = true;
			this.showRepConnKeystoreLocation = true;
			this.showRepConnKeystorePassword = true;
			this.showRepConnAgent = true;
			this.showRepConnSSLVersion = true;
		}
	}

	getAttributeColumns(objectWrapper: ObjectWrapper,
		attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, true),
			this.attributeTabulator.getNotNullFlag(objectWrapper),
			this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
			this.attributeTabulator.getOrderBy(objectWrapper, component),
			this.attributeTabulator.getDescription(objectWrapper),
		]
	}

	getLAttributeColumns(objectWrapper: ObjectWrapper = null,component): Array<any> {
			return [
				this.attributeTabulator.getCheckBoxColumn(objectWrapper),
				this.lAttributeTabulator.getSrt_Order(),
				this.lAttributeTabulator.getLAttr_Id(),
				this.lAttributeTabulator.getLAttrNm(objectWrapper),
				this.lAttributeTabulator.getSelectColumn(objectWrapper),
				this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
				this.lAttributeTabulator.getLAttrPrec(objectWrapper),
				this.lAttributeTabulator.getLAttrScale(objectWrapper),
				this.lAttributeTabulator.getLAttrType(objectWrapper),
				this.lAttributeTabulator.getLAttrFunction(objectWrapper),
				this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
				//this.lAttributeTabulator.getOrderBy(objectWrapper,component),
				this.lAttributeTabulator.getClusterKeyFlag(objectWrapper),
				this.lAttributeTabulator.getValid_Cd(objectWrapper)
			]
		}

	getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isComplex: boolean = false, isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false,isMax: boolean = false, component: any): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper, component),
		]
	}

	getConn_DbColumns(repConnWrapper: RepConnWrapper, component: any): Array<any> {
		console.log("this.conn_DbsTabultor.getSchemaNm(repConnWrapper, component)", this.conn_DbsTabultor.getSchemaNm(repConnWrapper, component));
		return [
			this.conn_DbsTabultor.getCheckBoxColumn(repConnWrapper),
			this.conn_DbsTabultor.getSrt_Order(),
			this.conn_DbsTabultor.getName(repConnWrapper),
			this.conn_DbsTabultor.getSchemaNm(repConnWrapper, component),
			this.conn_DbsTabultor.getStgDb_Flag(repConnWrapper)
		]
	}

}
